app.factory(
    'WorldpayConfigService',
    /**
     * @param hydrator
     * @param CurrentDevice
     * @param {PaymentMethodService} paymentMethodService
     * @param UserService
     */
    function (
        hydrator,
        CurrentDevice,
        paymentMethodService,
        UserService
    ) {
        let config = new DigiTickets.Worldpay.Config();

        let paymentMethod = paymentMethodService.getByRef('card-worldpay-chip-and-pin');
        if (!paymentMethod) {
            throw new Error('Company does not have Worldpay payment method enabled.');
        }

        // Set config from the company's payment method config.
        if (paymentMethod.config) {
            let companyTerminalConfig = JSON.parse(paymentMethod.config);
            hydrator.hydrate(companyTerminalConfig, config);
        }

        // Set config from the device's payment method config.
        let device = CurrentDevice.device;
        if (device.paymentTerminalConfig) {
            if (device.paymentTerminalConfig.hasOwnProperty('card-worldpay-chip-and-pin')) {
                hydrator.hydrate(device.paymentTerminalConfig['card-worldpay-chip-and-pin'], config);
            }
        }

        // Set config from the user's payment method config.
        if (UserService.paymentTerminalConfig) {
            if (UserService.paymentTerminalConfig.hasOwnProperty('card-worldpay-chip-and-pin')) {
                hydrator.hydrate(UserService.paymentTerminalConfig['card-worldpay-chip-and-pin'], config);
            }
        }

        return config;
    }
);

app.service('WorldpayDriverService', DigiTickets.Worldpay.Driver);
